import { timerActions } from "../../../store/timerSlice"
import { UrlConstant } from "../../../urlConstant/UrlConstant"
import { useHttpRequest } from "../../../utils"
import useCallBack, { Callbacks } from "../../../utils/callback/useCallBack"

export const GetRunningTimerMutation = <T>(resourceId:string, callbacks?: Callbacks<T>) => {
    const { onError, onLoading, onSuccess } = useCallBack<any>(callbacks)

    const { postRequest } = useHttpRequest({})
    return async (dispatch: any) => {
        const getTimers = async () => {
            try {
                const response = await postRequest(`${UrlConstant.Timer}/${UrlConstant?.GetByFiltered}`,{resourceId})
                const data = await response
                return data
            }
            catch (error) {
                onError(error as Error)
            }
        }
        try {
            const res = await getTimers()
            if (res) {
                const timer = res?.data?.find((d:any)=>d.isTimerRunning) ?? null
                const currentTimer = res?.data?.find((d:any)=>Boolean(d?.id)) ?? null
                dispatch(timerActions.getCurrentTimer(currentTimer ?? {}))
                dispatch(timerActions.getRecord(timer ?? {}))
                onSuccess(timer)
            } else {
                dispatch(timerActions.getRecord({}))
            }

        } catch (error) {
            onError(error as Error)
        } finally {
            onLoading(false)
        }
    }
}
